import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { setupCache } from 'axios-cache-adapter';
import _omit from 'lodash/omit';
import _size from 'lodash/size';
import _flow from 'lodash/flow';
import _keys from 'lodash/keys';
import { setValueInLocalStorage, getValueFromLocalStorage, removeValueFromLocalStorage } from '../../utils/localStorage';
var cache = setupCache({
  maxAge: 15 * 60 * 1000,
  // 15 minutes
  exclude: {
    methods: ['get', 'post', 'patch', 'put', 'delete']
  },
  debug: false
});
export var API_CACHE_STORAGE_TYPE = {
  LOCAL_STORAGE: 'LOCAL_STORAGE',
  IN_MEMORY_STORAGE: 'IN_MEMORY_STORAGE'
};
var memoryCacheGetItem = cache.store.getItem;
var memoryCacheSetItem = cache.store.setItem;
var memoryCacheRemoveItem = cache.store.removeItem;
var memoryCacheClearItem = cache.store.clear;
var memoryCacheLengthItem = cache.store.length;
var DEFAULT_CACHE = 'apiCache';

var getDefaultCacheFromLocalStorage = function getDefaultCacheFromLocalStorage() {
  return JSON.parse(getValueFromLocalStorage(DEFAULT_CACHE) || '{}');
};

cache.store.getItem = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var key, _ref$storageType, storageType, cacheStore;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            key = _ref.key, _ref$storageType = _ref.storageType, storageType = _ref$storageType === void 0 ? API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE : _ref$storageType;

            if (!(storageType === API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", memoryCacheGetItem.bind(cache.store)(key));

          case 3:
            cacheStore = getDefaultCacheFromLocalStorage();
            return _context.abrupt("return", Promise.resolve(cacheStore[key]));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

cache.store.setItem = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, value) {
    var key, _ref3$storageType, storageType, cacheStore;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            key = _ref3.key, _ref3$storageType = _ref3.storageType, storageType = _ref3$storageType === void 0 ? API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE : _ref3$storageType;

            if (!(storageType === API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", memoryCacheSetItem.bind(cache.store)(key, value));

          case 3:
            cacheStore = _objectSpread(_objectSpread({}, getDefaultCacheFromLocalStorage()), {}, _defineProperty({}, key, value));
            return _context2.abrupt("return", Promise.resolve(setValueInLocalStorage(DEFAULT_CACHE, JSON.stringify(cacheStore))));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();

cache.store.removeItem = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5, value) {
    var key, _ref5$storageType, storageType, cacheStore;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            key = _ref5.key, _ref5$storageType = _ref5.storageType, storageType = _ref5$storageType === void 0 ? API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE : _ref5$storageType;

            if (!(storageType === API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE)) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return", memoryCacheRemoveItem.bind(cache.store)(key, value));

          case 3:
            cacheStore = _omit(getDefaultCacheFromLocalStorage(), [key]);
            return _context3.abrupt("return", Promise.resolve(setValueInLocalStorage(DEFAULT_CACHE, JSON.stringify(cacheStore))));

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();

cache.store.clear = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var storageTypesSet, promiseToResolve;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            storageTypesSet = _ref7.storageTypesSet;
            promiseToResolve = [];
            if (storageTypesSet.has(API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE)) promiseToResolve.push(memoryCacheClearItem.bind(cache.store)());
            if (storageTypesSet.has(API_CACHE_STORAGE_TYPE.LOCAL_STORAGE)) promiseToResolve.push(Promise.resolve(removeValueFromLocalStorage(DEFAULT_CACHE)));
            return _context4.abrupt("return", Promise.all(promiseToResolve));

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x6) {
    return _ref8.apply(this, arguments);
  };
}();

cache.store.length = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var key, _ref9$storageType, storageType;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            key = _ref9.key, _ref9$storageType = _ref9.storageType, storageType = _ref9$storageType === void 0 ? API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE : _ref9$storageType;

            if (!(storageType === API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE)) {
              _context5.next = 3;
              break;
            }

            return _context5.abrupt("return", memoryCacheLengthItem.bind(cache.store)(key));

          case 3:
            return _context5.abrupt("return", Promise.resolve(_flow(_keys, _size)(getDefaultCacheFromLocalStorage())));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x7) {
    return _ref10.apply(this, arguments);
  };
}();

export default cache;